import { render, staticRenderFns } from "./freeUser.vue?vue&type=template&id=3ccc7bec"
import script from "./freeUser.vue?vue&type=script&lang=js"
export * from "./freeUser.vue?vue&type=script&lang=js"
import style0 from "./freeUser.vue?vue&type=style&index=0&id=3ccc7bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports